import { render, staticRenderFns } from "./QaListItem.vue?vue&type=template&id=3fb223e3&"
import script from "./QaListItem.vue?vue&type=script&lang=js&"
export * from "./QaListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports